import { render, staticRenderFns } from "./FurnitureService.vue?vue&type=template&id=dd5f3668&"
import script from "./FurnitureService.vue?vue&type=script&lang=js&"
export * from "./FurnitureService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports